import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';

import axios, { AxiosResponse } from 'axios';
import {
    STORE_ERROR_FILES_UPLOADED,
    STORE_ERROR_FILES_UPLOADED_MSG
} from 'src/reducers/errors';
import { inputCharacterHandeling } from './supportAction';
import { BranchData, LabData, STORE_M_BRANCH_DATA, STORE_M_CHOSEN_BRANCH_DATA, STORE_M_CHOSEN_LAB_DATA, STORE_M_FILES_UPLOAD, STORE_M_LAB_DATA, STORE_M_PROGRESS, STORE_M_SENDING_INPROGRESS, } from 'src/reducers/mfileupload';
import { getUTCDateTime } from './fileuploadAction';
import { STORE_ORDERDATATAT } from 'src/reducers/fileUpload';

export const getLabData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    axios({
        method: 'get',
        url: `${getState().environment.API_URL}getLabData`,
        headers: {
            sessionid: getState().user.userDetails.s || ''
        }
    }).then(responseOrderdatalab => {
        if (responseOrderdatalab.data[0].custcode) {
            const mlabData: LabData[] = responseOrderdatalab.data;
            dispatch({ type: STORE_M_LAB_DATA, mlabData } as AnyAction);

        } else {
            const mlabData: LabData[] = [];
            dispatch({ type: STORE_M_LAB_DATA, mlabData } as AnyAction);
        }

    }).catch(errorOrderdatalab => {
        const mlabData: LabData[] = [];
        dispatch({ type: STORE_M_LAB_DATA, mlabData } as AnyAction);
    });
};

export const saveLabList = (mlabChosen: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_M_CHOSEN_LAB_DATA, mlabChosen } as AnyAction);

        dispatch({ type: STORE_M_CHOSEN_BRANCH_DATA, mbranchType: '0' } as AnyAction);

        dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload: [] } as AnyAction);
        dispatch({ type: STORE_M_PROGRESS, mprogress: [] } as AnyAction);

        const selectedLab = getState().mfileupload.mlabData.filter((user) => user.custcode === mlabChosen);

        if (selectedLab.length > 0) {

            axios({
                method: 'post',
                url: `${getState().environment.API_URL}loadOrderData?listType=tat&lab=${mlabChosen}`,
                headers: {
                    sessionid: getState().user.userDetails.s || ''
                }
            }).then(responseOrderdatatat => {
                const orderDataTat = responseOrderdatatat.data;
                dispatch({ type: STORE_ORDERDATATAT, orderDataTat } as AnyAction);

            }).catch(errorOrderdatat => {
                console.error('Error ::: TatTypeGet', errorOrderdatat);
            });

            axios({
                method: 'post',
                url: `${getState().environment.API_URL}loadOrderData?listType=sbuiv&userCode=${selectedLab[0].uname}`,
                headers: {
                    sessionid: getState().user.userDetails.s || ''
                }
            }).then(responseOrderdataSBU => {
                if (responseOrderdataSBU.data[0].sbu_name) {
                    const mbranchData: BranchData[] = responseOrderdataSBU.data;
                    dispatch({ type: STORE_M_BRANCH_DATA, mbranchData } as AnyAction);
                } else {
                    const mbranchData: BranchData[] = [];
                    dispatch({ type: STORE_M_BRANCH_DATA, mbranchData } as AnyAction);
                }

            }).catch(errorOrderdataSBU => {

                const mbranchData: BranchData[] = [];
                dispatch({ type: STORE_M_BRANCH_DATA, mbranchData } as AnyAction);

                const errorFileUploadedOpen = true;
                const errorfilemsg = `Something went wrong`;

                dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
                dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            });

        } else {

            const errorFileUploadedOpen = true;
            const errorfilemsg = `Something went wrong`;

            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
        }

        return true;
    };
};

export const mOnFileChange = (filesNew: Array<File>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        const mlabChosen = getState().mfileupload.mlabChosen;
        
        const selectedLab = getState().mfileupload.mlabData.filter((user) => user.custcode === mlabChosen);

        if (selectedLab.length > 0 && getState().mfileupload.mbranchType !== '0') {

            filesNew.map((file, index) => {
                const x = filesNew[index];
                Object.defineProperties(x, {
                    'filename': {
                        value: file.name,
                        writable: true,
                        enumerable: true
                    },
                    'manufactType': {
                        value: selectedLab[0].destination ? selectedLab[0].destination : 'In-House',
                        writable: true,
                        enumerable: true
                    },
                    'designSoftware': {
                        value: selectedLab[0].dsoft ? selectedLab[0].dsoft : '3Shape',
                        writable: true,
                        enumerable: true
                    },
                    'model': {
                        value: 'N',
                        writable: true,
                        enumerable: true
                    },
                    'tat': {
                        value: selectedLab[0].tat ? selectedLab[0].tat : 'Next Day 7 AM',
                        writable: true,
                        enumerable: true
                    }

                });
                filesNew[index] = x;
                filesNew.join();
            });

            const filterfile: Array<File> = getState().mfileupload.mfilesUpload.concat(filesNew);
            const seen = new Set();
            const files2 = filterfile.filter(el => {
                const duplicate = seen.has(JSON.parse(JSON.stringify(el)).filename);
                seen.add(JSON.parse(JSON.stringify(el)).filename);
                return !duplicate;
            });
            if (files2.length > 0) {
                dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload: files2 } as AnyAction);
                filesNew.length = 0;
            }
        } else {

            const errorFileUploadedOpen = true;
            const errorfilemsg = `Please select the Lab and Business Unit`;

            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
        }

        filesNew.length = 0;

        return true;
    };
};

//  Onchange values from filestable view part
export const saveMaterialType = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const mfilesUpload = [...getState().mfileupload.mfilesUpload];
        const x = mfilesUpload[index];
        Object.defineProperty(x, 'material', { value: value, writable: true, enumerable: true });
        mfilesUpload[index] = x;
        mfilesUpload.join();
        dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
        return true;
    };
};
export const saveTatType = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const mfilesUpload = [...getState().mfileupload.mfilesUpload];
        const x = mfilesUpload[index];
        Object.defineProperty(x, 'tat', { value: value, writable: true, enumerable: true });
        mfilesUpload[index] = x;
        mfilesUpload.join();
        dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
        return true;
    };
};
export const saveManufactType = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const mfilesUpload = [...getState().mfileupload.mfilesUpload];
        const x = mfilesUpload[index];
        Object.defineProperty(x, 'manufactType', { value: value, writable: true, enumerable: true });
        mfilesUpload[index] = x;
        mfilesUpload.join();
        dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
        return true;
    };
};
export const saveDesignSoftware = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const mfilesUpload = [...getState().mfileupload.mfilesUpload];
        const x = mfilesUpload[index];
        Object.defineProperty(x, 'designSoftware', { value: value, writable: true, enumerable: true });
        mfilesUpload[index] = x;
        mfilesUpload.join();
        dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
        return true;
    };
};
export const saveOrderModel = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const mfilesUpload = [...getState().mfileupload.mfilesUpload];
        const x = mfilesUpload[index];
        Object.defineProperty(x, 'model', { value: value, writable: true, enumerable: true });
        mfilesUpload[index] = x;
        mfilesUpload.join();
        dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
        return true;
    };
};
export const saveDesignApproval = (event: React.ChangeEvent<HTMLInputElement>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const mfilesUpload = [...getState().mfileupload.mfilesUpload];
        const index = parseInt(event.target.value, 10);

        if (event.target.checked === true) {
            const x = mfilesUpload[index];
            Object.defineProperty(x, 'approval', { value: true, writable: true, enumerable: true });
            mfilesUpload[index] = x;
            mfilesUpload.join();
            dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
        } else {
            const x = mfilesUpload[index];
            Object.defineProperty(x, 'approval', { value: false, writable: true, enumerable: true });
            mfilesUpload[index] = x;
            mfilesUpload.join();
            dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
        }

        return true;
    };
};
export const saveIsBravo = (event: React.ChangeEvent<HTMLInputElement>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const mfilesUpload = [...getState().mfileupload.mfilesUpload];
        const index = parseInt(event.target.value, 10);

        if (event.target.checked === true) {
            const x = mfilesUpload[index];
            Object.defineProperty(x, 'bravopremium', { value: true, writable: true, enumerable: true });
            mfilesUpload[index] = x;
            mfilesUpload.join();
            dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload: mfilesUpload } as AnyAction);
        } else {
            const x = mfilesUpload[index];
            Object.defineProperty(x, 'bravopremium', { value: false, writable: true, enumerable: true });
            mfilesUpload[index] = x;
            mfilesUpload.join();
            dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload: mfilesUpload } as AnyAction);
        }

        return true;
    };
};
export const saveMessegeOrder = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const mfilesUpload = [...getState().mfileupload.mfilesUpload];
        const x = mfilesUpload[index];
        Object.defineProperty(x, 'msg', { value: value, writable: true, enumerable: true });
        mfilesUpload[index] = x;
        mfilesUpload.join();
        dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
        return true;
    };
};
export const saveBranchType = (mbranchType: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_M_CHOSEN_BRANCH_DATA, mbranchType } as AnyAction);
        return true;
    };
};

export const saveDrPreferences = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const mfilesUpload = [...getState().mfileupload.mfilesUpload];
        const x = mfilesUpload[index];
        Object.defineProperty(x, 'drPreferences', { value: value, writable: true, enumerable: true });
        mfilesUpload[index] = x;
        mfilesUpload.join();
        dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
        return true;
    };
};

export const saveBookingId = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const mfilesUpload = [...getState().mfileupload.mfilesUpload];
        const x = mfilesUpload[index];
        Object.defineProperty(x, 'bookingId', { value: value, writable: true, enumerable: true });
        mfilesUpload[index] = x;
        mfilesUpload.join();
        dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
        return true;
    };
};

// edited by yuvaraj
export const onUploadAllFilesAsync = (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const files = [...getState().mfileupload.mfilesUpload];
    const usercode = getState().user.userDetails.userName;

    const filesCheck = files.filter((file) => {
        return JSON.parse(JSON.stringify(file)).selected === true;
    });

    let msending = true;
    dispatch({ type: STORE_M_SENDING_INPROGRESS, msending } as AnyAction);

    if (filesCheck.length === 0) {
        const errorFileUploadedOpen = true;
        const errorfilemsg = `Please select files before clicking 'SEND' button`;
        dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
        msending = false;
        dispatch({ type: STORE_M_SENDING_INPROGRESS, msending } as AnyAction);
        return;
    }

    const selectedLab = getState().mfileupload.mlabData.filter((user) => user.custcode === getState().mfileupload.mlabChosen);

    // const sessionid = getState().user.userDetails.s;
    const businessUnit = getState().mfileupload.mbranchType;

    files.map((file: File, index: number) => {

        const mfilesUpload = [...getState().mfileupload.mfilesUpload];

        if (JSON.parse(JSON.stringify(file)).selected === true && (JSON.parse(JSON.stringify(file)).uploaded === false || JSON.parse(JSON.stringify(file)).uploaded === undefined)) {

            msending = true;
            dispatch({ type: STORE_M_SENDING_INPROGRESS, msending } as AnyAction);
            console.log(file, 'file');

            const formData = new FormData();
            formData.append('scanfile', file);
            formData.append('msg', inputCharacterHandeling(JSON.parse(JSON.stringify(file)).msg) || '');
            formData.append('appType', 'b2b_m');
            formData.append('bravo', JSON.parse(JSON.stringify(file)).bravopremium === true ? '1' : '0');
            formData.append('filesize', file.size.toString());
            formData.append('uploadedBy', getState().user.userDetails.userName || '');
            formData.append('drPreferences', JSON.parse(JSON.stringify(file)).drPreferences || '');
            formData.append('bookingId', inputCharacterHandeling(JSON.parse(JSON.stringify(file)).bookingId) || '');

            axios({
                method: 'post',
                url: `${getState().environment.ORDER_UPLOAD_URL}easyUploadAync`,
                data: formData,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/multipart/form-data',
                    tat: JSON.parse(JSON.stringify(file)).tat || '',
                    material: '',
                    design: '',
                    // msg: inputCharacterHandeling(JSON.parse(JSON.stringify(file)).msg) || '',
                    customersbu: businessUnit || '',
                    destination: JSON.parse(JSON.stringify(file)).manufactType || '',
                    dsoft: JSON.parse(JSON.stringify(file)).designSoftware || '',
                    model: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : JSON.parse(JSON.stringify(file)).model || 'N',
                    modelonly: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : 'N',
                    designapproval: JSON.parse(JSON.stringify(file)).approval === true ? '1' : '0',
                    servicetype: '0',
                    lab: selectedLab[0].custcode || '',
                    usercode: usercode || selectedLab[0].uname,
                    sessionid: '',
                    requesttime: getUTCDateTime(new Date())
                },
                onUploadProgress: (progressEvent) => {

                    const mprogress = [...getState().mfileupload.mprogress];
                    const tempProgress: number = Math.round((progressEvent.loaded * 100) / progressEvent.total) || 0;
                    mprogress[index] = tempProgress;
                    dispatch({ type: STORE_M_PROGRESS, mprogress } as AnyAction);

                    const x = mfilesUpload[index];
                    Object.defineProperty(x, 'uploaded', { value: 'uploading', writable: true, enumerable: true });
                    mfilesUpload[index] = x;
                    dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
                }
            }).then(function (response: AxiosResponse) {

                msending = true;
                dispatch({ type: STORE_M_SENDING_INPROGRESS, msending } as AnyAction);

                const uploaded = mfilesUpload[index];
                Object.defineProperty(uploaded, 'uploaded', { value: true, writable: true, enumerable: true });
                mfilesUpload[index] = uploaded;
                mfilesUpload.join();
                dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);

                msending = false;
                dispatch({ type: STORE_M_SENDING_INPROGRESS, msending } as AnyAction);

            }).catch(error => {

                msending = false;
                dispatch({ type: STORE_M_SENDING_INPROGRESS, msending } as AnyAction);

                const uploadFailed = mfilesUpload[index];

                Object.defineProperty(uploadFailed, 'uploaded', { value: false, writable: true, enumerable: true });
                mfilesUpload[index] = uploadFailed;
                mfilesUpload.join();
                dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);

                const mprogress = [...getState().mfileupload.mprogress];
                if (mprogress[index] === 100) {
                    const fileUploadedError = mfilesUpload[index];

                    Object.defineProperties(fileUploadedError, {
                        'uploaded': {
                            value: false,
                            writable: true,
                            enumerable: true
                        },
                        'errorReason': {
                            value: (error.response.data.msg).includes('ORA-00001') ? 'Duplicate file' : '',
                            writable: true,
                            enumerable: true
                        }
                    });
                    mfilesUpload[index] = fileUploadedError;
                    mfilesUpload.join();
                    dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);

                    msending = false;
                    dispatch({ type: STORE_M_SENDING_INPROGRESS, msending } as AnyAction);
                }

                mprogress[index] = 0;
                // progress.join();
                dispatch({ type: STORE_M_PROGRESS, mprogress } as AnyAction);

                msending = false;
                dispatch({ type: STORE_M_SENDING_INPROGRESS, msending } as AnyAction);

                dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);

            });
        } else {
            msending = false;
            dispatch({ type: STORE_M_SENDING_INPROGRESS, msending } as AnyAction);
        }

    });

    return true;
};

export const onUploadType = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    onUploadAllFilesAsync(dispatch, getState);
};

export const onRefreshStatus = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const mfilesUpload: Array<File> = [...getState().mfileupload.mfilesUpload];
    dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
    const mprogress: Array<number> = [...getState().mfileupload.mprogress];
    dispatch({ type: STORE_M_PROGRESS, mprogress } as AnyAction);

    return true;
};

//  Editing table structure of filestable
export const deleteRowbyId = (event: React.ChangeEvent<{ value: string }>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        const mfilesUpload = [...getState().mfileupload.mfilesUpload];
        const mprogress = [...getState().mfileupload.mprogress];

        const filesindex = mfilesUpload.map((e) => {
            return JSON.parse(JSON.stringify(e)).filename;
        }).indexOf(event.currentTarget.value as string);

        if (filesindex >= 0) {
            mfilesUpload.splice(filesindex, 1);
            dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
            mprogress.splice(filesindex, 1);
            dispatch({ type: STORE_M_PROGRESS, mprogress } as AnyAction);
        }
    };
};

export const onClearAllUploaded = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const mprogress = getState().mfileupload.mprogress;
    const files = [...getState().mfileupload.mfilesUpload];

    const mfilesUpload = files.filter((file, index) => {
        if (JSON.parse(JSON.stringify(file)).uploaded === true) {
            mprogress[index] = 0;
            mprogress.join();
        }
        return JSON.parse(JSON.stringify(file)).uploaded !== true;
    });

    if (files.length > mfilesUpload.length) {
        const selectAll = document.querySelector('#selectAll') as HTMLInputElement;
        if (selectAll !== null && selectAll.checked === true) {
            selectAll.click();
        }
    }

    dispatch({ type: STORE_M_PROGRESS, mprogress } as AnyAction);
    dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);

    return true;
};
export const onClearAllFiles = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    if (getState().mfileupload.mfilesUpload > []) {
        const mfilesUpload: Array<File> = [];
        dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
        const mprogress: Array<number> = [];
        dispatch({ type: STORE_M_PROGRESS, mprogress } as AnyAction);
    }
    const selectAll = document.querySelector('#mselectAll') as HTMLInputElement;
    if (selectAll !== null && selectAll.checked === true) {
        selectAll.click();
    }
    const msending = false;
    dispatch({ type: STORE_M_SENDING_INPROGRESS, msending } as AnyAction);
    return true;
};

export const onSelectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const mfilesUpload = [...getState().mfileupload.mfilesUpload];

        const index = parseInt(event.target.value, 10);
        if (JSON.parse(JSON.stringify(mfilesUpload[index])).tat !== undefined) {

            if (event.target.checked === true) {
                const x = mfilesUpload[index];
                Object.defineProperty(x, 'selected', { value: true, writable: true, enumerable: true });
                mfilesUpload[index] = x;
                mfilesUpload.join();
                dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
            } else {
                const x = mfilesUpload[index];
                Object.defineProperty(x, 'selected', { value: false, writable: true, enumerable: true });
                mfilesUpload[index] = x;
                mfilesUpload.join();
                dispatch({ type: STORE_M_FILES_UPLOAD, mfilesUpload } as AnyAction);
            }
        } else {
            const errorFileUploadedOpen = true;
            const errorfilemsg = `Please select ' TAT ' for ${mfilesUpload[index].name}`;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
        }

    };
};

export const onSelectAllFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const files: Array<File> = getState().mfileupload.mfilesUpload;

        files.map((file, index) => {
            const namefile = `#${JSON.parse(JSON.stringify(file)).id}`;
            const selectCheck = document.querySelector(namefile) as HTMLInputElement;
            if (selectCheck !== null && selectCheck.checked === false && event.target.checked === true) {
                selectCheck.click();
            } else if (selectCheck !== null && selectCheck.checked === true && event.target.checked === false) {
                selectCheck.click();
            } else if (selectCheck !== null && selectCheck.checked === true && event.target.checked === true) {
                return;
            }

        });
    };
};



// WEBPACK FOOTER //
// ./src/actions/mfileuploadAction.ts